import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Use setTimeout to ensure the DOM has updated and layout is calculated
        const timer = setTimeout(() => {
            if (hash) {
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                window.scrollTo(0, 0);
                document.documentElement.scrollTo(0, 0);
                document.body.scrollTo(0, 0);

                // Also try to scroll the root element if it's the scroll container
                const root = document.getElementById('root');
                if (root) {
                    root.scrollTo(0, 0);
                }
            }
        }, 0);

        return () => clearTimeout(timer);
    }, [pathname, hash]);

    return null;
}
